import { noop } from "../utils/event.js";
import { dataAttributesFromTheme } from "../utils/theme.js";
import { createContext, useContext, useMemo } from "react";
//#region src/hooks/use-color-theme.ts
const _ThemeColorContext = createContext(null);
const ThemeColorContext = _ThemeColorContext.Provider;
const DEFAULT_THEME_COLOR_MANAGER = {
	mode: "light",
	brand: "design",
	enhancedContrast: false
};
const DEFAULT_ADD_THEME_LISTENER = () => noop;
/**
* Reads the current color theme — its `mode`, `brand`, and `enhancedContrast`.
* Use it to perform logic that can't be expressed with an FPL token alone.
*
* It can also apply `overrides` on top of the ambient theme and return the
* pieces needed to apply that theme yourself — `dataAttributes` and a `Context`
* provider — for the case where you need to control where those go rather
* than wrapping the subtree in a `ColorTheme`.
*/
function useColorTheme(overrides = {}) {
	const themeContext = useContext(_ThemeColorContext);
	if (!themeContext) {
		if (globalThis.process?.env?.NODE_ENV !== "test") console.debug("No theme provider exists currently, returning defaults, but switching modes is disabled");
	}
	const brand = overrides.brand ?? themeContext?.brand ?? DEFAULT_THEME_COLOR_MANAGER.brand;
	const mode = overrides.mode ?? themeContext?.mode ?? DEFAULT_THEME_COLOR_MANAGER.mode;
	const enhancedContrast = overrides.enhancedContrast ?? themeContext?.enhancedContrast ?? DEFAULT_THEME_COLOR_MANAGER.enhancedContrast;
	const addThemeListener = themeContext?.addThemeListener ?? DEFAULT_ADD_THEME_LISTENER;
	return useMemo(() => ({
		mode,
		brand,
		enhancedContrast,
		addThemeListener,
		dataAttributes: dataAttributesFromTheme({
			mode,
			brand,
			enhancedContrast
		}),
		Context: ThemeColorContext
	}), [
		mode,
		brand,
		enhancedContrast,
		addThemeListener
	]);
}
//#endregion
export { ThemeColorContext, useColorTheme };

//# sourceMappingURL=use-color-theme.js.map